import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Remove the build-time pre-rendered SEO content (public/index.html + scripts/prerender.js)
// the moment the app bundle runs, so visitors only ever see the React UI.
const prerendered = document.getElementById("seo-prerender");
if (prerendered) prerendered.remove();

// The static <title>/<meta description> in index.html exist only for crawlers that
// don't run JS. react-helmet-async inserts its own page-specific tags, which would
// leave the homepage title behind as a *second* <title>. Drop the static ones first.
document.querySelectorAll("head > title, head > meta[name='description']").forEach((el) => el.remove());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
